import { FormField, type OnChange } from "@common/controls/Form/component";
import { TextInput } from "@common/controls/Inputs/Text";
import { type OptionItem } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { usePromise } from "@common/lib/hooks";
import { i18nFormat } from "@common/lib/i18n";
import { type Account } from "@common/modules/account/types";
import * as React from "react";
import { type IRecipientFields } from "../types";
import { type AddUpdateRecipientFormData } from "./AddUpdateModal";
import { getCryptoValidation } from "./lib";

type Props = {
  ref: React.RefObject<IRecipientFields | null>;
  getBlockchainNetworks: () => Promise<OptionItem<string>[]>;
  onChange: OnChange<AddUpdateRecipientFormData>;
  values: AddUpdateRecipientFormData;
};

export default (props: Props) => {
  const i18n = useI18n();

  const [blockchainNetworkOptions] = usePromise<OptionItem<string>[]>({
    fn: props.getBlockchainNetworks,
    args: [],
    shouldLoad: true
  });

  React.useImperativeHandle(
    props.ref,
    () => ({
      getValues: (data: AddUpdateRecipientFormData): Promise<Account.View.BeneficiarySettings> => {
        return Promise.resolve({
          data: {
            crypto: {
              blockchainNetwork: data.blockchainNetwork!,
              walletAddress: data.walletAddress!
            }
          },
          currencyCode: data.currencyCode,
          name: data.name
        });
      }
    }),
    [props.values]
  );

  return (
    <>
      <FormField
        Component={TextInput}
        componentProps={{ maxLength: 128 }}
        isRequired
        label={i18n.friendlyName}
        name="name"
        value={props.values.name}
        qa="Name"
      />
      <FormField
        Component={TextInput}
        isRequired
        label={i18n.walletAddress}
        name="walletAddress"
        value={props.values.walletAddress}
        validator={getCryptoValidation(props.values.blockchainNetwork!)}
        hint={i18nFormat(i18n.infoWalletAddress, [
          "BLOCKCHAIN_NETWORK",
          (blockchainNetworkOptions ?? []).find((x) => x.value === props.values.blockchainNetwork)?.label
        ])}
        qa="Wallet address"
      />
    </>
  );
};
